import classNames from 'classnames';
import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom';
import { Can } from '../../_contexts/AbilitiesContext';

import './style.css'

export default function SideMenu({ history }) {
  let { path } = useRouteMatch();

  function isActive(path) {
    return history.location.pathname.includes(path) ? "active" : "";
  }

  const usersClass = classNames('nav-item', {
    'nav-border-top': !isActive(`${path}/users`)
    
  })
  
  const rolesClass = classNames('nav-item', {
    'nav-border-top': isActive(`${path}/locations`),
    'nav-border-bottom': !isActive(`${path}/roles`) && !isActive(`${path}/locations`)
  })

  const locationClass = classNames('nav-item', {
    'nav-border-bottom': !isActive(`${path}/locations`)
  })

  const servicesClass = classNames('nav-item', {
    'nav-border-bottom': !isActive(`${path}/services`)
  })

  return (
    <nav id="sideMenu" className="col-md-3 col-lg-2 d-md-block pt-5">
      <ul className="nav flex-column">
        <li className="nav-title lead">
          Manage Account
        </li>

        <Can I="manage" a="users">
          <li className={usersClass}>
            <Link className={"nav-link " + isActive(`${path}/users`)} to="/account/users">
              <div className="row">
                <div className="col-2 pr-1 my-auto">
                  <i className="fas fa-user fa-fw" aria-hidden="true"></i>
                </div>
                <div className="col">
                  <div className="row">
                    <div className="col">
                      <span>Users</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-muted font-weight-light">
                      <span>Manage Users</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </li>
        </Can>

        <Can I="manage" a="roles">
          <li className={rolesClass}>
            <Link className={"nav-link " + isActive(`${path}/roles`)} to="/account/roles">
              <div className="row">
                <div className="col-2 pr-1 my-auto">
                  <i className="far fa-building fa-fw" aria-hidden="true"></i>
                </div>
                <div className="col">
                  <div className="row">
                    <div className="col">
                      <span>Roles</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-muted font-weight-light">
                      <span>Manage Roles</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </li>          
        </Can>

        <Can I="manage" a="locations">
          <li className={locationClass}>
            <Link className={"nav-link " + isActive(`${path}/locations`)} to="/account/locations">
              <div className="row">
                <div className="col-2 pr-1 my-auto">
                  <i className="far fa-building fa-fw" aria-hidden="true"></i>
                </div>
                <div className="col">
                  <div className="row">
                    <div className="col">
                      <span>Locations</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-muted font-weight-light">
                      <span>Manage Locations</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </li>          
        </Can>

        <li className={servicesClass}>
          <Link className={"nav-link " + isActive(`${path}/services`)} to="/account/services">
            <div className="row">
              <div className="col-2 pr-1 my-auto">
                <i className="fas fa-cogs" aria-hidden="true"></i>
              </div>
              <div className="col">
                <div className="row">
                  <div className="col">
                    <span>Services</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col text-muted font-weight-light">
                    <span>Manage Services</span>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </li>          

      </ul>
    </nav>
    )
}
